import {NgModule, APP_INITIALIZER} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule} from "@angular/forms";
import {initializeApp} from "@app/app-initializer";
import {HttpClientModule, HTTP_INTERCEPTORS} from "@angular/common/http";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {AppRoutingModule} from "./app-routing.module";
import {AppComponent} from "./app.component";
import {CSRFRequestInterceptor} from "./interceptors/csrf-request.interceptor";
import {AppConfig} from "./services/app.config";
import {AuthorizationInterceptor} from "./interceptors/authorization.interceptor";
import {BrowseModule} from "@app/modules/browse/browse.module";
import {LoginModule} from "@app/modules/login/login.module";
import {SFTPAPIService} from "@app/services/sftp-api/sftp-api.service";
import {WINDOW_PROVIDERS} from "@app/services/window.service";
import {CookiePolicyModalModule} from "@app/shared/components/cookie-policy-modal/cookie-policy-modal.module";
import {CookieService} from "ngx-cookie-service";

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowseModule,
    HttpClientModule,
    FormsModule,
    LoginModule,
    BrowserAnimationsModule,
    CookiePolicyModalModule,
  ],
  providers: [
    WINDOW_PROVIDERS,
    CookieService,
    SFTPAPIService,
    {provide: HTTP_INTERCEPTORS, useClass: CSRFRequestInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: AuthorizationInterceptor, multi: true},
    AppConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig, SFTPAPIService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
